import axios, { AxiosRequestConfig, AxiosResponse } from 'axios';

export function createCache(expiryMinutes = 5, initialCache = {}) {
  const cache: Record<
    string,
    {
      expiry: number; // new Date().getTime() epoch milliseconds
      request: Promise<AxiosResponse>;
    }
  > = initialCache;

  function hasCache(key: string) {
    const now = new Date();
    const entry = cache[key];
    if (!entry) {
      return false;
    }
    if (entry.expiry <= now.getTime()) {
      // invalidate cache it has expired
      delete cache[key];
      return false;
    }
    return true;
  }

  function resetCache(key: string) {
    const entry = cache[key];
    if (!entry) {
      return;
    }

    delete cache[key];
  }

  function cachedRequest({
    key,
    config,
  }: {
    key: string;
    config: AxiosRequestConfig<any>;
  }): Promise<AxiosResponse> {
    if (hasCache(key)) {
      return cache[key].request;
    }
    const request = axios(config);
    cache[key] = {
      expiry: new Date().getTime() + expiryMinutes * 60 * 1000,
      request,
    };
    return request;
  }

  return {
    hasCache,
    cachedRequest,
    resetCache,
  };
}

export default createCache();
